import * as React from 'react';
import { TabHeader, TabPanelContainer } from '.';
export class Tabs extends React.Component {
    constructor(props) {
        super(props);
        this.headerRefs = [];
        this.findTitles = () => {
            if (Array.isArray(this.props.children)) {
                const titles = [].map.call(this.props.children, (child) => {
                    return {
                        title: child.props.title,
                        key: child.key,
                    };
                });
                return this.setState({ titles });
            }
            this.setState({ titles: [{ title: this.props.children.props.title, key: this.props.children.props.name }] });
        };
        this.state = {
            titles: [],
            activeKey: props.defaultActiveKey,
            inkStyle: {
                top: 0,
                left: 0,
                width: 0,
            },
        };
    }
    componentDidMount() {
        this.findTitles();
    }
    render() {
        const { titles, activeKey } = this.state;
        return (React.createElement("div", null,
            React.createElement(TabHeader, { titles: titles, activeKey: activeKey, onClick: (key) => this.setState({ activeKey: key }) }),
            React.createElement(TabPanelContainer, { titles: titles, activeKey: activeKey, unMountOnChange: this.props.unMountOnChange || false }, this.props.children)));
    }
}
//# sourceMappingURL=Tabs.js.map